<rid-demo-page [title]="'Categoriseren'" previousRoute="/mechanics/sorting">
  <rid-button class="w-full" content="Sorteren (gemend)" variant="PRIMARY" routerLink="mixed" />

  <br />

  <rid-button class="w-full" content="Sorteren | woord & beeld (+audio)" variant="PRIMARY" routerLink="word-to-image" />
  <rid-button class="w-full" content="Sorteren | woord & audio" variant="PRIMARY" routerLink="word-to-audio" />
  <rid-button class="w-full" content="Sorteren | woord & regelsymbool" variant="PRIMARY" routerLink="word-to-rule" />
  <rid-button class="w-full" content="Sorteren | audio & woord" variant="PRIMARY" routerLink="audio-to-word" />
</rid-demo-page>
